// Fallback to Number if BigInt is not available
// Fixes old versions of Safari/iOS
if (typeof (BigInt) === 'undefined') {
  window.BigInt = Number
}
